import React from 'react';
import { PropTypes } from 'prop-types';
import { toast } from 'react-toastify';
import { push } from 'react-router-redux';

import { CRUD } from './queries';
import I18N from '../../common/i18n';
import { withApolloAsyncLoad, getSectionLinkBody } from '../../../base/utils';
import { store } from '../../..';
import { 
  // AppSections, 
  Sections 
} from '../../common/enums';
import ZoneForm from './ZoneForm';
import { decodeGeometry, closePolygon } from 'base/utils';
import { actions as sectionActions} from '../common/actions';

export default
class ZoneEdit extends React.PureComponent {
  static title = I18N.ZONES_EDIT_TITLE

  static propTypes = {
    itemId: PropTypes.number.isRequired,
    manifestId: PropTypes.number,
    orgId: PropTypes.number,
  }

  _update = (update, data) => {
    const p = update({
      variables: {
        id: this.props.itemId,
        data: data
      }
    });
    p.then((res) => {
      toast.success(`${I18N.ZONES_EDIT_TITLE}. ${I18N.NOTIFY_SUCCESS}`);
      store.dispatch(push(
        `${getSectionLinkBody(this.props.manifestId)}${Sections.ZONES}`
      ));
      store.dispatch(sectionActions.zoneGeometryUpdated(res.data.result.id, closePolygon(decodeGeometry(res.data.result.geometry)), 'form'));
    });
    p.catch((res) => {
      toast.error(`${I18N.ZONES_EDIT_TITLE}. ${I18N.NOTIFY_ERROR}`);
      console.log('update error');
    });
    return p;
  }

  _renderForm = (zone) => (
    CRUD.UPDATE(
      {},
      (update) => (
        <ZoneForm
          key={zone.id}
          {...this.props}
          submitText={I18N.SUBMIT_SAVE}
          item={zone}
          submit={(data) => this._update(update, data)} />
      )
    )
  );

  render() {
    return (
      CRUD.GET_ONE(
        {id: this.props.itemId},
        (result) => withApolloAsyncLoad(this._renderForm, result)
      )
    );
  }
}
